import { AuthguardService } from './../config/authguard.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddEmployeesComponent } from './add-employees/add-employees.component';
import { EmployeesListComponent } from './employees-list/employees-list.component';
import { EmployeeDetailsComponent } from './employee-details/employee-details.component';
import { EmployeeAddStatusComponent } from './employee-add-status/employee-add-status.component';
import { BulkUploadEmployeesComponent } from './bulk-upload-employees/bulk-upload-employees.component';

const routes: Routes = [
  {
    path: 'employees-list',
    // component : EmployeesListComponent,
    children: [
      { path: '', component: EmployeesListComponent, canActivate: [AuthguardService] },
      // { path: 'employees-list', component: EmployeesListComponent },
      { path: 'add-employees', component: AddEmployeesComponent },
      { path: 'add-employees/employee-add-status', component: EmployeeAddStatusComponent },
      { path: 'bulk-upload-employees', component: BulkUploadEmployeesComponent },
      // children:[
      //   { path: 'add-employees', component: AddEmployeesComponent },
      //   { path: 'employee-add-status', component: EmployeeAddStatusComponent },
      // ] },
      { path: 'employee-details', component: EmployeeDetailsComponent },

      // { path: 'add-employees', component: AddEmployeesComponent }
    ]
  }

];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class EmployeesRoutingModule { }
